
class FormOfferResponse extends require('common/helpers/validate') {
   // Validation schema
   get schema() {
      return {
         agree_terms: {
            required: true,
            type: 'checkbox'
         },
         agree_declaration: {
            required: true,
            type: 'checkbox'
         },
         healthcare: {
            required: true
         }
      }
   }
}

module.exports = FormOfferResponse
